import { useTranslation } from 'react-i18next';

export const GetGreetingsHeader = () => {
  const { t } = useTranslation(['dashboard']);
  const hour = new Date().getHours();

  if (hour < 9) {
    return t('greetings.goodMorning');
  }
  if (hour < 12) {
    return t('greetings.goodDay');
  }
  if (hour < 18) {
    return t('greetings.goodAfternoon');
  }
  return t('greetings.goodEvening');
};
